import React, { useState } from 'react';
import { navLinks } from '../mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-charcoal/90 backdrop-blur-md border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#home" className="font-display text-yellow text-xl tracking-tight">
          LLIT-Media<span className="text-white">.de</span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.slice(1).map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm text-zinc-200 hover:text-yellow transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          className="lg:hidden text-yellow"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-800 bg-charcoal">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            {navLinks.slice(1).map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-zinc-200 hover:text-yellow py-2 font-medium"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
